












































import { PatchBatchDocument, PriceListModel } from '@/libs/Api';
import { priceListsStore } from '@/libs/price-lists/+state/store';
import { CrudAction, CrudReponse, CrudResponseAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import PriceListDialog from '@/libs/settings/components/PriceListDialog.vue';
import DeleteDialog from '@/libs/common/components/DeleteDialog.vue';

import draggable from 'vuedraggable'
import moment from 'moment';
import {cloneDeep} from "lodash";

@Component({
    components: {
        PriceListDialog,
        draggable
    }
})
export default class PriceLists extends Page {

    @Prop() tenantId!: string;

    get loading(): boolean {
        return priceListsStore.useGetter(CrudGetter.Pending);
    }

    get items (): PriceListModel[] {
        return priceListsStore.useGetter(CrudGetter.Data);
    }

    @Ref() dialog!: PriceListDialog;
    
    mounted () {
        this.loadItems();
    }

    loadItems () {
        priceListsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PriceListModel>([
            { field: "fromDate", index: 1, order: "desc" }
        ], undefined));
    }

    createItemClick () {
        let fromDate = moment().format("YYYY-MM-DDT00:00:00");
        let toDate = moment().endOf("year").format("YYYY-MM-DDT23:59:59");
        if (this.items?.length > 0) {
            const lastItem = this.items.orderByDescending(x => moment(x.fromDate).toDate()).first();
            fromDate = moment(lastItem.toDate).add(1, "day").format("YYYY-MM-DDT00:00:00");
            if (moment(fromDate).isSame(moment(fromDate).endOf("year").startOf("day"))) {
                toDate = moment(fromDate).add(1, "year").endOf("year").format("YYYY-MM-DDT23:59:59");
            }
            else {
                toDate = moment(fromDate).endOf("year").format("YYYY-MM-DDT23:59:59");
            }
        }
        this.dialog.create(fromDate, toDate);
    }

    openItemClick (v: PriceListModel) {
        this.dialog.open(v.id);
    }

	clone(v: PriceListModel) {
		const priceLists = priceListsStore.useGetter(CrudGetter.Data) as PriceListModel[];
		const lastDate = priceLists.orderByDescending(x => moment(x.toDate).toDate()).firstOrDefault()?.toDate ?? moment("YYYY-MM-DD HH:mm:ss");
		const newFromDate = moment(lastDate).add(1, "days").startOf("day").format("YYYY-MM-DD HH:mm:ss");
		const newToDate = moment(newFromDate).endOf("year").format("YYYY-MM-DD HH:mm:ss");
		const newItem = cloneDeep(v);
		newItem.fromDate = newFromDate;
		newItem.toDate = newToDate;
		this.dialog.openCloned(newItem);
	}

}
